exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".device-software-version-button{border:1px solid #ddd;padding:5px 10px;background:none}.device-software-version-button:hover{background:#bbb}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/System/SettingsDevices.vue"],"names":[],"mappings":"AACA,gCACC,sBAAuB,AACvB,iBAAkB,AAClB,eAAiB,CACjB,AACD,sCACC,eAAoB,CACpB","file":"SettingsDevices.vue","sourcesContent":["\n.device-software-version-button {\n\tborder: 1px #ddd solid;\n\tpadding: 5px 10px;\n\tbackground: none;\n}\n.device-software-version-button:hover {\n\tbackground: #bbbbbb;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64c190ec","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/System/SettingsDevices.vue
// module id = 2225
// module chunks = 4